export default "/images/vendor/flag-icon-css/flags/4x3/gb-nir.svg?8ad03581959bce8c3da0e389104cf1e3";